import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
} from "@fortawesome/free-solid-svg-icons";
import {
  Navbar,
  NavbarToggler,
} from "reactstrap";
import { useHistory, useLocation } from "react-router-dom";

import LocalStorageService from "../utils/localStorageServices";
// import SOURCES from "../utils/constants";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import Notifications from "./notifications";
import { Button, Dropdown } from "antd";
import {
  LogoutOutlined,
  UserOutlined,
  // LockOutlined
} from "@ant-design/icons";
// import { Avatar, Space } from "antd";
import { getTitle } from "../utils/helper";
const localStorageServices = LocalStorageService.getService();

const Topbar = ({ toggleSidebar }) => {
  // const currentUser = localStorageServices.getCurrentUser();
  // const userType = currentUser.user?.userType;
  const [topbarIsOpen, setTopbarOpen] = useState(false);
  const toggleTopbar = () => setTopbarOpen(!topbarIsOpen);
  const [toggle, setToggle] = useState(false);
  const loggedUser = localStorageServices.getCurrentUser().user;
  const logOut = () => {
    localStorageServices.clearToken();
    window.location.reload();
  };
  const history = useHistory();
  const location = useLocation();

  return (
    <Navbar
      className="navbar  sticky top-0 z-50 relative !p-0"
      expand="md"
    >
      {/* Blur layer */}
      {/* <div className="absolute -top-10 left-0 w-full h-20 bg-secondary/5 backdrop-blur-[2px] z-0" /> */}

      {/* Content */}
      <div className="relative z-10 flex justify-between items-center w-full bg-white py-3 sm:!px-6 px-2 rounded-none mb-3">

        <div className="flex items-center gap-x-4">
          <Button color="primary" onClick={() => toggleSidebar(true)} className="hover:!border-primary hover:!text-primary">
            <FontAwesomeIcon icon={faBars} size="sm" />
          </Button>
          {/* Center Section: Responsive Title */}
          <h1 className="text-base xs:block hidden sm:text-xl lg:text-2xl font-semibold flex-1 truncate">
            {getTitle(location.pathname)}
          </h1>
        </div>

        {/* Right Section: Actions (Always Visible) */}
        <div className="flex items-center gap-2 sm:gap-4 shrink-0">
          <Notifications />

          <Dropdown
            onOpenChange={(next) => setToggle(next)}
            popupRender={() => (
              <div className="bg-white min-w-[240px] sm:min-w-[270px] min-h-fit rounded-md shadow-lg flex flex-col overflow-hidden">
                {/* HEADER */}
                <div className="px-3 py-2 border-b border-secondary/15 sticky top-0 bg-white z-10">
                  <div className="gap-3 flex items-center">
                    <div className="!size-10 rounded-full !bg-primary overflow-hidden flex justify-center items-center shrink-0">
                      <p className="text-lg capitalize text-white font-medium !leading-none !tracking-wide">
                        {loggedUser.name
                          .split(" ")
                          .slice(0, 2)
                          .map((name) => name.charAt(0))
                          .join("")}
                      </p>
                    </div>
                    <div className="min-w-0">
                      <h6 className="text-base-content text-base font-semibold truncate leading-tight">
                        {loggedUser.name}
                      </h6>
                      <p className="w-full text-xs sm:text-sm font-normal truncate opacity-70">
                        {loggedUser.email}
                      </p>
                    </div>
                  </div>
                </div>

                {/* content */}
                <div className="px-3 py-2 flex flex-col space-y-1 sm:space-y-2">
                  <Button
                    className="!flex items-center justify-start border-none relative px-3 py-2 text-gray-900 rounded-lg hover:!bg-gray-100 hover:!text-primary text-sm sm:text-base font-medium gap-2 h-auto"
                    icon={<UserOutlined />}
                    onClick={() => history.push("/profile")}
                  >
                    Profile
                  </Button>
                </div>

                {/* FOOTER */}
                <div className="px-3 py-2 border-t border-secondary/15 sticky bottom-0 bg-white z-10 flex justify-center">
                  <Button
                    className="!bg-primary text-white w-full hover:!bg-primary hover:!border-primary text-xs sm:text-sm font-medium h-8 sm:h-9"
                    icon={<LogoutOutlined />}
                    onClick={logOut}
                  >
                    Sign out
                  </Button>
                </div>
              </div>
            )}
            trigger={["click"]}
          >
            <Button
              id="dropdown-avatar"
              type="button"
              className="border !border-primary hover:!text-primary flex items-center gap-1 sm:gap-2 rounded-full px-1.5 sm:px-2 h-9 sm:h-10 sm:min-w-[130px] sm:max-w-[160px] max-w-fit transition-all"
            >
              <div className="size-6 sm:size-8 rounded-full flex-shrink-0 overflow-hidden !bg-primary flex justify-center items-center">
                <p className="text-[10px] sm:text-sm capitalize text-white font-medium !leading-none !tracking-wide">
                  {loggedUser.name
                    .split(" ")
                    .slice(0, 2)
                    .map((name) => name.charAt(0))
                    .join("")}
                </p>
              </div>
              <div className="flex items-center gap-x-3">
                <span className="text-xs sm:text-sm truncate sm:block hidden  max-w-none">{loggedUser.name}</span>
                {toggle ? (
                  <FaAngleUp className="text-xs sm:text-sm ml-0.5 shrink-0" />
                ) : (
                  <FaAngleDown className="text-xs sm:text-sm ml-0.5 shrink-0" />
                )}
              </div>
            </Button>
          </Dropdown>
        </div>
      </div>
    </Navbar>
  );
};

export default Topbar;
